import { render, staticRenderFns } from "./Aggregate.vue?vue&type=template&id=648ce1f0&"
import script from "./Aggregate.vue?vue&type=script&lang=js&"
export * from "./Aggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports